"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "caldaro-sulla-strada-del-vino": {
    "27eaddfe": [{
      "hkey": "90264e7e",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "caldaro-centro": [{
      "hkey": "90264e7e",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8934e6a6": [{
      "hkey": "acae46a2",
      "slug": "caldaro-sulla-strada-del-vino",
      "name": "Caldaro sulla strada del vino",
      "primary": true,
      "skipSearch": false
    }],
    "san-nicolo": [{
      "hkey": "acae46a2",
      "slug": "caldaro-sulla-strada-del-vino",
      "name": "Caldaro sulla strada del vino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "416a8820": [{
      "hkey": "acae46a2",
      "slug": "caldaro-sulla-strada-del-vino",
      "name": "Caldaro sulla strada del vino",
      "primary": true,
      "skipSearch": false
    }],
    "sant-antonio-pozzo": [{
      "hkey": "acae46a2",
      "slug": "caldaro-sulla-strada-del-vino",
      "name": "Caldaro sulla strada del vino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1a988a19": [{
      "hkey": "acae46a2",
      "slug": "caldaro-sulla-strada-del-vino",
      "name": "Caldaro sulla strada del vino",
      "primary": true,
      "skipSearch": false
    }],
    "villa-di-mezzo": [{
      "hkey": "acae46a2",
      "slug": "caldaro-sulla-strada-del-vino",
      "name": "Caldaro sulla strada del vino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;